<template>
  <div style="height: 100%">
    <router-view style="height: calc(100% - 70px)"/>
    <van-tabbar v-model="active" @change="tabSwitch3" route class="footer_s">
      <van-tabbar-item v-for="(item,key) in tabList" :key="key" :to="item.href">
        <span>{{item.tabTitle}}</span>
        <template #icon="props">
          <img class="footer_img" :src="props.active ? item.activeIcon : item.icon" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
  import {mapActions, mapState} from 'vuex'

  export default {
    name: 'NavBottom',
    data() {
      return {
        active:'',
        tabList: [
          {
            'tabTitle': this.$t('append_field.terminal'),
            'curr': false,
            'icon': '/static/images/terminal/terminal.png',
            'activeIcon': '/static/images/terminal/activate-terminal.png',
            'href': '/information',
          },
          {
            'tabTitle': this.$t('append_field.program'),
            'curr': false,
            'icon': '/static/images/terminal/program.png',
            'activeIcon': '/static/images/terminal/activate-program.png',
            'href': '/programs',
          },
          {
            'tabTitle': this.$t('append_field.my'),
            'curr': false,
            'icon': '/static/images/terminal/my.png',
            'activeIcon': '/static/images/terminal/activate-my.png',
            'href': '/my',
          },
        ]
      }
    },
    computed: {
      ...mapState({
        topTitle: state => state.topTitle,
        topBackIconShow: state => state.topBackIconShow,
        parentPage: state => state.parentPage
      })
    },
    mounted() {
      let url = window.location.hash
      for (let i = 0; i < this.tabList.length; i++) {
        if (url === this.tabList[i].href) {
          this.tabList[i].curr = true
        }
      }
    },
    methods: {
      ...mapActions(['changeTopTitle', 'changeTopIconStatus', 'setParentPage']),
      tabSwitch3: function (value) {
        // this.topTitle = value.tabTitle
        this.changeTopTitle(this.tabList[value].tabTitle)
        this.changeTopIconStatus(false)
      },
      goBack() {
        this.$router.push({path: this.parentPage})
        if (this.parentPage == 'taskdetail') {
          this.changeTopTitle(this.$t('append_field.task_details'))
          this.setParentPage('programs')
        } else if (this.parentPage == 'programs') {
          this.changeTopTitle(this.$t('append_field.program'))
          this.changeTopIconStatus(false)
        } else if (this.parentPage == 'my') {
          this.changeTopTitle(this.$t('append_field.my'))
          this.changeTopIconStatus(false)
        } else if (this.parentPage == 'programs') {
          this.changeTopTitle(this.$t('append_field.program'))
          this.changeTopIconStatus(false)
        } else if (this.parentPage == 'information') {
          this.changeTopTitle(this.$t('append_field.terminal'))
          this.changeTopIconStatus(false)
        }
      }
    },
  }
</script>

<style lang="scss">
.footer_s{
  background: #F2F2F2;
  border-top: 1px solid #ccc;
  height: 70px;
  .van-tabbar-item{
    font-size: 16px;
  }
  .footer_img{
    margin: 0 auto;
    width: 30px;
    height: 30px;
    display: block;
    background-size: 100% 100%;
    background-position: 50%;
  }
  .van-tabbar-item--active{
    background-color: #F2F2F2;
  }
}
  .topTitle {
    height: 40px;
    background: #006EFF;
    line-height: 40px;
    color: #fff;
    position: relative;
    text-align: center;

    .topTitle-icon {
      position: absolute;
      left: 10px;
      top: 10px;
      font-size: 25px;
    }
  }

  .van-dialog-ok {
    background: #fff;
    border-top: 1px solid #F6F6F6;
    color: #006EFF;
  }

  .van-dialog-title {
    font-weight: 600;
    color: #333 !important;
    text-align: left !important;

  }

  .van-dialog-footer {
    justify-content: flex-end;
    border: none;
    height: 55px;
  }

  .van-dialog-btn {
    height: 35px;
    line-height: 35px;
    padding: 0 10px;
    width: 60px;
    flex: none;
    margin-left: 10px;
    border-radius: 5px;
  }

  .van-dialog-cancel {
    border: 1px solid #e41f19;
    color: #e41f19;
  }

  .van-dialog-cancel:active {
    background: #fff;
    border: 1px solid #e41f19;
  }

  .van-dialog-ok {
    border: 1px solid #006EFF;
    color: #fff;
    background: #006EFF;
    margin-right: 20px;
  }

  .van-dialog-ok:active {
    background: #006EFF;
  }

  .van-dialog__header {
    font-size: 18px !important;
    font-weight: bold;
  }

  .van-dialog__content {
    //padding-top: 15px!important;
    font-size: 18px !important;
  }



  .van-picker {
    .van-picker__toolbar {
      border-bottom: 1px solid #ddd;
      color: #333;

      .van-picker__cancel {
        color: #ee0a24;
      }
    }
  }
</style>
